import React from 'react';
import Icon from '../../../../components/AppIcon';

const StatisticsPanel = ({ stats }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-6">
        Your Progress
      </h3>
      <div className="space-y-6">
        {stats?.map((stat) => (
          <div key={stat?.id} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Icon name={stat?.icon} size={18} color="var(--color-primary)" />
                <span className="text-sm font-medium text-foreground">
                  {stat?.label}
                </span>
              </div>
              <span className="text-sm font-semibold text-foreground">
                {stat?.value}
              </span>
            </div>
            {stat?.progress !== undefined && (
              <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                <div 
                  className="h-full bg-primary transition-all duration-300 ease-out"
                  style={{ width: `${stat?.progress}%` }}
                />
              </div>
            )}
            {stat?.trend && (
              <div className="flex items-center gap-1">
                <Icon 
                  name={stat?.trend > 0 ? 'TrendingUp' : 'TrendingDown'} 
                  size={14} 
                  color={stat?.trend > 0 ? 'var(--color-success)' : 'var(--color-error)'} 
                />
                <span className={`text-xs font-medium ${stat?.trend > 0 ? 'text-success' : 'text-error'}`}>
                  {Math.abs(stat?.trend)}% from last week
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatisticsPanel;